module.exports = __webpack_public_path__ + "static/media/tubos.7f114446.jpg";